import { TextAreaField } from "@/components/TextAreaField/TextAreaField";
import { useMetadataFields } from "@/components/MetadataFields/hooks";

type Props = {
  disabled: boolean;
};

const Description = ({ disabled }: Props) => {
  const { updateMetadata, activeAsset, isMetadataUpdating } =
    useMetadataFields();
  const isupdating = isMetadataUpdating(activeAsset.id!, "description");
  return (
    <TextAreaField
      id="description"
      type="textarea"
      labelText="Asset description"
      disabled={disabled || isupdating}
      initialValue={activeAsset.description || ""}
      onBlur={(value: string) => {
        updateMetadata({
          description: value,
        });
      }}
    />
  );
};

export default Description;
